export default __webpack_public_path__ + "static/media/ArrowIcon.28121107.svg";